import React, {useState, useEffect} from "react"
import puzzleAnswerData from "../puzzleAnswerData"

function MapVisualInput(props) {
    const [puzzleComplete, setPuzzleComplete] = useState(false)
    const [mapInput, setMapInput] = useState("")
    const [mapCode] = useState(puzzleAnswerData[5].mapCode)
    const letters = ["A", "B", "C", "D", "E", "F"]
    const numbers = ["", 1, 2, 3, 4, 5, 6]
    const coordinates = ["a1", "a2", "a3", "a4", "a5", "a6", "b1", "b2", "b3", "b4", "b5", "b6", "c1", "c2", "c3", "c4", "c5", "c6", "d1", "d2", "d3", "d4", "d5", "d6", "e1", "e2", "e3", "e4", "e5", "e6", "f1", "f2", "f3", "f4", "f5", "f6"]

    function submitMap(event) {
        const {id} = event.target
        document.getElementById(id).style.background = "firebrick"
        document.getElementById(id).style.opacity = "40%"
        setMapInput(prevInput => prevInput + id)
    }
    
    function triggerOverlay() {
        const show = "on"
        const text = "Investigation of the first two hideouts turn up... nothing. Just as Larry thinks about giving up, you find the door to the third hideout."
        const trigger = "map"
        const complete = true
        props.callBackOverlay(show, text, trigger)
        props.callBackStatus(trigger, complete)
        props.callBackRevealClues("The Switches", "Hideout Locations")
    }
    
    useEffect(() => {
        if (mapInput.length >= 6) {
            if (mapInput.includes(mapCode.hideoutOne) && mapInput.includes(mapCode.hideoutTwo) &&     mapInput.includes(mapCode.hideoutThree)) {
                setTimeout(() => setPuzzleComplete(true), 250)
            } else {
                setTimeout(() => resetMap(), 250)   
            }
        } 
    }, [mapInput, mapCode])
    
    useEffect(() => {
        if (puzzleComplete) {
            triggerOverlay()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [puzzleComplete])
    
    function resetMap() {
        setMapInput("")
        const mapButtons = Array.from(document.querySelectorAll(".mapButton"))
        mapButtons.map(button => { 
            return (
                button.style.background = "transparent",
                button.style.opacity = "100%"
            )
        })
    }
    
    const letterReference = letters.map((value, index) => {
        return <h1 key={index} className="mapReference">{value}</h1>
    })
    
    const numberReference = numbers.map((value, index) => {
        return <h1 key={index} className="mapReference">{value}</h1>
    }) 
    
    const mapCoordinates = coordinates.map((value, index) => {
        return <button key={index} className="mapButton" id={value} onClick={submitMap}></button>
    })
    
    return (
        <div className="imageTextWrapper mapWrapper">
            <div className="mapUnderlay">
                <img className="map" src={"images/map.jpg"} alt="a map of new york" />
                <div className="letterReference">
                    {letterReference}
                </div>

                <div className="numberReference">
                    {numberReference}
                </div>
            </div>

            <div className="mapOverlay">
                {mapCoordinates}
            </div>
        </div>
    )
}

export default MapVisualInput